import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Button} from '@customink/pigment-react';

import './TrayButton.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function TrayButton(props) {
  const {
    label,
    onClick,
    icon,
    alternated: isAlternate,
    reversed: isReversed,
    flipped: isFlipped,
    multipleItems,
    ...otherProps
  } = props ?? {};
  const buttonClass = classnames('ndx-TrayButton', {
    isAlternate,
    isReversed,
    isFlipped
  });

  const iconClasses = classnames('ndx-TrayButton-icon', {multipleItems});

  return (
    <Button
      size="large"
      variant={isAlternate ? 'primary' : 'secondary'}
      className={buttonClass}
      classes={{startIcon: iconClasses, endIcon: iconClasses}}
      {...(isReversed ? {endIcon: icon} : {startIcon: icon})}
      {...otherProps}
      onClick={onClick}>
      {label}
    </Button>
  );
}

const propTypes = {
  alternated: PropTypes.bool,
  'data-testid': PropTypes.string,
  flipped: PropTypes.bool,
  icon: PropTypes.element,
  label: PropTypes.string,
  multipleItems: PropTypes.bool,
  reversed: PropTypes.bool,
  onClick: PropTypes.func
};

TrayButton.propTypes = propTypes;
